import axios, { AxiosInstance } from 'axios';

let logoutCallback: () => Promise<void> | void = () => {
  console.warn('Global logout callback not set - 401 error ignored');
};

let hasLogoutCallbackBeenSet = false;

export const setGlobalLogoutCallback = (
  callback: () => Promise<void> | void
) => {
  logoutCallback = callback;
  hasLogoutCallbackBeenSet = true;
  console.log('Global logout callback has been set');
};

export const setupGlobalErrorHandler = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const sensitive = error?.config?.carecircleSensitive === true;
      if (axios.isAxiosError(error)) {
        if (error.response) {
          // The request was made and the server responded with a status code
          switch (error.response.status) {
            case 401:
              console.error('Unauthorized access - triggering logout');
              if (hasLogoutCallbackBeenSet) {
                try {
                  await logoutCallback();
                  console.log('Automatic logout completed successfully');
                } catch (logoutError) {
                  console.error('Error during automatic logout:', logoutError);
                }
              } else {
                console.error('401 error but logout callback not set');
              }
              break;
            case 403:
              console.error('Forbidden — API returned 403');
              break;
            case 404:
              console.error('Not Found');
              break;
            case 500:
              console.error('Server Error');
              break;
          }
        } else if (sensitive) {
          return Promise.reject(new Error('survey_outcome_unknown'));
        } else if (error.request) {
          // The request was made but no response was received.
          // This can happen due to transient network issues or CORS-blocked
          // responses. Do NOT logout — only a genuine 401 should cause logout.
          console.error(
            'No response received — possible network or CORS issue',
            error.request
          );
        } else {
          // Something happened in setting up the request
          console.error('Error setting up request', error.message);
        }
      }
      return Promise.reject(sensitive ? new Error('survey_outcome_unknown') : error);
    }
  );
};
